<template>
    <div>
        <el-form :inline="true" :model="searchForm" @submit.native.prevent >

            <el-form-item label="操作时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary"  @click="getListHandler($event)">搜索查询</el-button>
                <span>
                    <a class="export-tamplate" @click="exportHandle()">下载模板</a>
                </span> 
            </el-form-item>

            <el-form-item class="btnArea">
                <el-button type="primary" @click="importCardVisible = true" >批量变更语音状态</el-button>
            </el-form-item>
        </el-form> 

        <el-table :data="tbpg.tableData" border height="611">
            <el-table-column type="index" label="序号" width="50" ></el-table-column>
            <el-table-column prop="stateName" label="转为状态"  ></el-table-column>
            <el-table-column prop="total" label="总卡数"  ></el-table-column>
            <el-table-column prop="successTotal" label="成功数"  ></el-table-column>
            <el-table-column label="失败数"  >
                <template slot-scope="scope">
                    <span style="color: red;">{{ scope.row.failTotal>0?scope.row.failTotal:''}}</span>
                </template>
            </el-table-column>
            <el-table-column  label="操作时间"  width="150">
                <template slot-scope="scope">
                    {{dateFormat('yyyy-MM-dd hh:mm:ss', new Date(scope.row.createTime))}}
                </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注"></el-table-column>
            <el-table-column prop="agentName" label="操作人"></el-table-column>
            <el-table-column label="操作" width="80" >
                <template v-slot="scope" >
                    <el-button v-if="scope.row.failTotal>0" type="text" size="small" @click="endtimeChgRecordListHandle(scope.row.id, $event)">查看失败</el-button>
                </template>    
            </el-table-column>
        </el-table>  
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination> 



        <el-dialog title="批量变更语音状态" :visible.sync="importCardVisible" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="importCardForm" :model="importCardForm" :rules="importCardRules" label-width="100px">
                <el-form-item label="导入Excel：" prop="uploadExcel">
                    <el-upload ref="upload" :action="uploadUrl('sim/other/batch/upate/sim')" :headers="setHeader()" :auto-upload="false" :data="importCardForm" :on-change="handleChange" :on-success = "handleSuccess" :file-list="fileList">
                        <el-button slot="trigger" plain>导入Excel</el-button>
                        <el-button style="margin-left: 10px;" plain @click="exportHandle()">导出模板</el-button>
                    </el-upload>                        
                </el-form-item>  
                <el-form-item label="类型：" prop="states">
                    <el-radio-group v-model="importCardForm.states">
                        <el-radio label="0">开启基础语音功能</el-radio>
                        <el-radio label="1">关闭基础语音功能</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="备注：" width="80" prop="remark">
                    <el-input v-model="importCardForm.remark" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="sureImportCardHandle">确 定</el-button>
            </div> 
        </el-dialog> 



        <el-dialog title="批量变更语音状态" :visible.sync="failCardVisible" width="70%"  height="70%" :close-on-click-modal="false">
            <el-table  :data="failCardData" style="width: 100%">
                    <el-table-column type="index" label="序号" width="50"> </el-table-column>
                    <el-table-column prop="intoNo" label="接入号" width="180"> </el-table-column>
                    <el-table-column prop="remark" label="备注"></el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="failCardVisible = false">确 定</el-button>
            </div> 
        </el-dialog> 
     <el-dialog title="变更失败列表" :visible.sync="endtimeFailVisible" width="1000px" :close-on-click-modal="false">
            <el-table :data="tbpg_fail.tableData" border height="421">
                <el-table-column type="index" label="序号" width="50"> </el-table-column>
                <el-table-column prop="intoNo" label="接入号" width="200px"></el-table-column>
                <el-table-column prop="remark" label="错误描述"></el-table-column>
            </el-table>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="tbpg_fail.currentPage"
                :page-sizes="[10, 50, 100, 500]"
                :page-size="tbpg_fail.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tbpg_fail.total">
            </el-pagination>
        </el-dialog>         


    </div>
</template>

<script>
import common from '@/utils/common.js'
import {endtimeChgList, endtimeChg, endtimeChgRecordList1, getImportData, getImportDataQuery} from '@/api/endtime.js'
export default {
    data(){
        var checkImportFile = (rule, value, callback) => {
            var files = this.$refs.upload.uploadFiles
            var len = files.length;
            if(len > 0){
                var extName = files[0].name.split('.')[1].toLowerCase();
                if(extName != 'xls' && extName != 'xlsx'){
                    return callback(new Error('请选择要导入的Excel文件'));
                }else{
                    callback();
                }
            }else{
                return callback(new Error('请选择要导入的Excel文件'))
            }           
        }         
        return {
            searchForm: {
                time: null,
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },  

            failCardVisible: false,
            failCardData: [],

            importCardForm:{
                states: null,
                remark: null
            },
            fileList: [],
             endtimeFailVisible: false,
            tbpg_fail: {
                tableData: [],
                currentPage: 1,
                pageSize: 10,
                total: 0                
            },   

            importCardVisible: false,
            importCardRules: {
                uploadExcel: [{required: true, validator: checkImportFile}],
                states: [{required: true, message: '请选择卡状态', trigger: 'change'}],
                remark: [{required: true, message: '请填写备注', trigger: 'change'}]
            }         
        }
    },
    methods: {
        /**  列表数据搜索  **/
        getListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            let data = common.getRequestParams(this, 'tbpg', this.searchForm);            
            common.sysRequest('sim/other/batch/upate/sim/list', data, 'post').then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        endtimeChgRecordListHandle(id, $event){
            this.endtimeFailVisible = true;
            this.currentId_fail = id;
            var searchForm = {
                id: this.currentId_fail,
                state: 2
            }            
            common.resetCurrentPage(this, $event, 'tbpg_fail');
            var data = common.getRequestParams(this, 'tbpg_fail', searchForm);            
            endtimeChgRecordList1(data).then(res => {
                common.listCallback(this, res, 'tbpg_fail');
            })
        },     
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getListHandler(this.$event);
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getListHandler(this.$event);
        },

        handleChange(file, fileList) {
            if(fileList.length > 1){
                fileList.splice(0,1);
            }
            
        },
        /**  列表数据搜索  end **/

        //导出excel文件
        exportHandle(){
            this.exportExcel('/excel/sim/update', {});
            this.$message.success('下载中……');
        },
        //导出excel文件  end



        //批量修改卡状态  excel导入
        handleChange(file, fileList){
            if(fileList.length > 1){
                fileList.splice(0,1);
            }
            this.$refs.importCardForm.fields[0].clearValidate();
            console.log(this.fileList);
        },     
        handleSuccess(res){
            if(res.code == 200){
                this.getListHandler();
                
                this.$message.success(res.message);
            }else{
                this.$message.error(res.message);
            }
            this.importCardVisible = false;
        },   

        sureImportCardHandle(){
            this.$refs.importCardForm.validate(valid => {
                if(valid){
                    this.$refs.upload.submit();   //号段批量导入
                }
            })           
        },

        cancel(){
            this.fileList.pop();
            this.importCardForm.states = null;
            this.importCardVisible = false;
        },

        //批量修改卡状态  excel导入  end 


        //查看失败
        showFailCard(row){
            let newArray = [];
            let failCards = row.failIntono.split('_');
            for(let i=0; i<failCards.length; i++){
                newArray.push({
                    intoNo: failCards[i],
                    remark: row.failRemark
                });
            }
            this.failCardData = newArray;
            this.failCardVisible = true;
        }, 

    },
    created () {
        this.getListHandler(this.$event);
    }
}
</script>

<style lang="scss" scoped>

    .export-tamplate{
        box-sizing: border-box;
        border: 1px solid #dcdfe6;
        border-radius: 3px;
        width: 85px;
        height: 32px;
        display: inline-block;
        text-align: center;
        vertical-align: baseline;
        margin-left: 10px;
        font-size: 13px;
        color: #606266;
    }

    .export-tamplate:hover{
        color: #409EFF;
        border-color: #409EFF;
        transition: .3s;
    }

    .uploadUrl{
        box-sizing: border-box;
        border-radius: 3px;
        width: 180px;
        height: 64px;
        display: inline-block;
        vertical-align: baseline;
        margin-left: 10px;
        font-size: 13px;
        color: #606266;
    }


</style>

